import type { IMiniFlexTableProps } from "@similarweb/ui-components";
import { MiniFlexTable } from "@similarweb/ui-components";
import type { FlexTableColumnType } from "app/pages/sales-intelligence/types";
import { StyledWrapper } from "./styles";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

type Props = Pick<IMiniFlexTableProps, "data" | "className" | "noDataComponent" | "metadata"> & {
    columns: FlexTableColumnType[];
};

const ResultsTable = ({ className, data, columns, noDataComponent, metadata }: Props) => {
    const t = useTranslation();
    return (
        <StyledWrapper className={className}>
            <MiniFlexTable
                data={data}
                columns={columns}
                metadata={metadata}
                noDataComponent={noDataComponent}
                useStyledTable
                translations={{
                    outOf: t("common.minitable.pager.out_of"),
                    pages: t("Common.minitable.pager.pages"),
                }}
            />
        </StyledWrapper>
    );
};

export default ResultsTable;
